import { Settings } from '@backend/domain'
import { Injectable } from '@nestjs/common'
import { InjectRepository } from '@nestjs/typeorm'
import { Repository } from 'typeorm'
import { UserModifiableEntityRepository } from './generic'

@Injectable()
export class SettingsRepository extends UserModifiableEntityRepository<Settings> {
	constructor(@InjectRepository(Settings) override readonly _repository: Repository<Settings>) {
		super(_repository)
	}
}
